module.exports = __webpack_public_path__ + "static/media/card_empty.18ccb686.png";